// import dynamic from 'next/dynamic';

import { useAppContext } from '@/layouts/AppProvider';
import { CustomLink } from '@/types/Common';
import { MetaBaseStrapi } from '@/types/MetaData';

import MenuBar from '../MenuBar';
// const BackofficeMenu = dynamic(() => import('./BackofficeDesktopMenu'), { ssr: false });
// const ReplicatedMenu = dynamic(() => import('./ReplicatedDesktopMenu'), { ssr: false });

import BackofficeMenu from './BackofficeDesktopMenu';
import ReplicatedMenu from './ReplicatedDesktopMenu';

export default function DesktopMenu({
  dogCategories,
  dogIssues,
  catCategories,
  catIssues,
  ourStories,
  aboutUs,
  blogUrl,
  ingredientUrl,
  ezShipManagerPath,
  petProfilePath,
  businessReports,
  commissions,
  customerReports,
  events,
  petProfileAdmin,
  proTools,
  support,
  tools,
  dashboardUrl,
}: {
  dogCategories: MetaBaseStrapi[];
  dogIssues: MetaBaseStrapi[];
  catCategories: MetaBaseStrapi[];
  catIssues: MetaBaseStrapi[];
  ourStories: CustomLink[];
  aboutUs: CustomLink[];
  blogUrl: string;
  ingredientUrl: string;
  petProfilePath: string;
  ezShipManagerPath: string;
  tools: CustomLink[];
  commissions: CustomLink[];
  businessReports: CustomLink[];
  dashboardUrl: string;
  customerReports: CustomLink[];
  petProfileAdmin: CustomLink[];
  events: CustomLink[];
  proTools: CustomLink[];
  support: CustomLink[];
}) {
  const { isBackOffice } = useAppContext();
  return (
    <MenuBar>
      {isBackOffice ? (
        <BackofficeMenu
          aboutUs={aboutUs}
          blogUrl={blogUrl}
          ingredientUrl={ingredientUrl}
          businessReports={businessReports}
          catCategories={catCategories}
          catIssues={catIssues}
          commissions={commissions}
          customerReports={customerReports}
          dashboardUrl={dashboardUrl}
          dogCategories={dogCategories}
          dogIssues={dogIssues}
          events={events}
          ezShipManagerPath={ezShipManagerPath}
          ourStories={ourStories}
          petProfileAdmin={petProfileAdmin}
          petProfilePath={petProfilePath}
          proTools={proTools}
          support={support}
          tools={tools}
        />
      ) : (
        <ReplicatedMenu
          aboutUs={aboutUs}
          blogUrl={blogUrl}
          ingredientUrl={ingredientUrl}
          catCategories={catCategories}
          catIssues={catIssues}
          dogCategories={dogCategories}
          dogIssues={dogIssues}
          ezShipManagerPath={ezShipManagerPath}
          ourStories={ourStories}
          petProfilePath={petProfilePath}
        />
      )}
    </MenuBar>
  );
}
